"use strict";
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateLoggedInUserCookie = void 0;
var zod = _interopRequireWildcard(require("zod"));
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != (typeof e === "undefined" ? "undefined" : _type_of(e)) && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _$t in e)"default" !== _$t && ({}).hasOwnProperty.call(e, _$t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _$t)) && (i.get || i.set) ? o(f, _$t, i) : f[_$t] = e[_$t]);
        return f;
    })(e, t);
}
// This schema validates a string that fullfills this format: <tenant>\<consultantNumber>
var loggedInUserCookieSchema = zod.string().regex(/^[A-Za-z]{2}\\\d+$/);
/**
 * Validates the provided string against the loggedInUserCookie schema.
 *
 * @param cookieContent - The content of the logged-in user cookie to validate. It can be undefined.
 * @returns The validated logged-in user data if the validation is successful, otherwise `undefined`.
 */ var validateLoggedInUserCookie = function(cookieContent) {
    var result = loggedInUserCookieSchema.safeParse(cookieContent);
    if (result.success) {
        return result.data;
    }
    return undefined;
};
exports.validateLoggedInUserCookie = validateLoggedInUserCookie; //# sourceMappingURL=validateLoggedInUserCookie.js.map
